import {LOADING,ERROR,OBTENER_PARTIDOS} from '../types/partidos';

const INITIAL_STATE = {
    partidos:[],
    loading:false,
    error:null
}

export default (state=INITIAL_STATE,action)=>{
    switch(action.type){
        case OBTENER_PARTIDOS:
            return {...state,loading:false,error:null,partidos:action.payload}
        case LOADING:
            return{...state,loading:true}
        case ERROR:
            return{...state,loading:false,error:action.payload}
        default:
            return state;
    }
}